import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFilesForEnvironment } from '../../api/documentAPI';
import { deleteFiles } from '../../api/documentAPI';
import { useAtom } from 'jotai';
import { allowDeleteAtom } from '../../atoms/managedocs/useAllowDeleteAtom';
import { useSelectedEnvTypeAtom } from '../../atoms/managedocs/useSelectedEnvTypeAtom';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';

import ConfirmDeleteModal from '../shared/ConfirmDeleteModal';
import config from '../../config/configJS';

const DocumentsList = ({ id }) => {

    const { showNotification } = useNotification();

    const [t, ] = useTranslation('global');

    const [allowDelete, ] = useAtom(allowDeleteAtom);
    const [selectedEnvType,] = useSelectedEnvTypeAtom();

    const [documents, setDocuments] = useState([]);
    const [docIdToDelete, setDocIdToDelete] = useState(null);
    const [docNameToDelete, setDocNameToDelete] = useState('');
    const [, setIsLoading] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleOpen = (id, name) => {
      setDocIdToDelete(id); 
      setDocNameToDelete(name);
      setOpen(true);
    }

    const handleClose = () => {
      setDocIdToDelete(null);
      setOpen(false);
    }

    const handleNo = () => {
      handleClose();
    }

    const handleYes = () => { 
      console.log(docIdToDelete);
      handleDelete(docIdToDelete);
      handleClose();
    }

    const handleDelete = async (id) => {
      setIsLoading(true);
      try {
        await deleteFiles(id);
        await fetchData();
        showNotification({ message: t('filesDeleted'), type: NotificationType.Success });
      } finally {
        setIsLoading(false);
      }
    }

    const fetchData = async () => {
      if (!id) {
        setDocuments([]);
        return;
      }

      try {
        const data = await getFilesForEnvironment(id);
        setDocuments(Array.isArray(data) ? data : []);
      } catch (error) {
        console.warn('Failed to fetch documents for environment', id, error);
        setDocuments([]);
      }
    }    

    useEffect(() => {
      console.log('env id change in doclist');
      if(id) {
        fetchData();
      }
      }, [id]); 

    useEffect(() => {
      if (!id) {
        return;
      }

      const intervalId = setInterval(() => {
          fetchData();
      }, 5000);
      // Cleanup function to clear the interval and prevent potential memory leaks
      return () => {
          clearInterval(intervalId);
      };
    }, [id]);

  return (
    <div className="document-list">
        <h3>{t('documents')}</h3>
        {documents && !documents.length > 0 && <span>{t('folderEmpty')}</span>}

        <ConfirmDeleteModal 
            open={open} 
            onNo={handleNo}
            onYes={handleYes}
            onClose={handleClose}
            item={docNameToDelete}
        />

        {(documents ?? []).map((doc, key) => (
            <div key={key} className='doc-detail'>
                <span className='doc-name'>{doc.FileName}</span>             
                <div className='doc-status-wrap'>
                  <span className={'doc-status status-' + doc.Status}>{t('status_'+ doc.Status)}</span>     

                  {selectedEnvType === 'M' ? (
                          <a
                            target="_blank"
                            href={`${config.endPoint}/api/millai/DownloadFile?intent=GetFileById&id=${doc.Id}`}
                            className="material-symbols-outlined download-item-icon"
                          >
                            download
                          </a>
                        ) : selectedEnvType === 'S' && (
                          <a
                            target="_blank"
                            href={doc.Url + '?web=1'}
                            className="material-symbols-outlined download-item-icon"
                          >
                            open_in_new
                          </a>
                    )} 
                    
                  {allowDelete && (
                    <span className="material-symbols-outlined del-icon" onClick={()=> handleOpen(doc.Id, doc.FileName)}>close</span>
                  )}

   

                </div> 
            </div>
        ))}
    </div>

  );
}

export default DocumentsList;